module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/144-algeria-cfb6daeb0d00f7149bc72a27728abdc6.svg";